import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { ProColors } from '../../aura';

type PromptProps = {
  text: ReactNode;
};

export function Prompt(props: PromptProps): JSX.Element {
  return (
    <div
      className="aura--copy-normal"
      css={css({ color: ProColors.navy[800], fontWeight: 400 })}
    >
      {props.text}
    </div>
  );
}
